<!--{{ fields|json }}-->
<form [formGroup]="formGroup">
  <div class="row-wrapper">
    <h3>Create Note</h3>
    <div class="input-row">
      <div class="input-label">Note Action</div>
      <div formGroupName="properties">
        <div formGroupName="fields">
          <input type="text" formControlName="action" />
          @if (formGroup.get('properties.fields.action'); as actionControl) {
            @if (actionControl.invalid && (actionControl.dirty || actionControl.touched)) {
              <mat-icon
                class="required-icon"
                fontIcon="error_outlined"
                [matTooltip]="actionControl.hasError('maxlength') ? 'Maximum 30 characters allowed' : 'Information required'"
                matTooltipShowDelay="500"
              ></mat-icon>
            }
          }
        </div>
      </div>
    </div>
    <div class="input-row">
      <div class="input-label">Comments</div>
      @if (isDocusignAction) {
        <span class="message tip">
          <mat-icon fontIcon="info"></mat-icon>This will include a link to the Docusign envelope
        </span>
      }
      @if (isSaveToEntityAction) {
        <span class="message tip">
          <mat-icon fontIcon="info"></mat-icon>This will include document details including where it has been saved
        </span>
      }
    </div>
    <mat-icon
      class="remove"
      fontIcon="close"
      [matTooltip]="'Remove action'"
      matTooltipShowDelay="500"
      (click)="removeAction()"
      (keydown.enter)="removeAction()"
      (keydown.space)="removeAction()"
      tabindex="0"
    >
    </mat-icon>
  </div>
</form>
